/* global axios */
import ApiClient from '../ApiClient';

class AiAssistantsReportsAPI extends ApiClient {
  constructor() {
    super('reports/ai_assistants', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  getSummary({ since, until, teamId, agentId, granularity, businessHours } = {}) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        team_id: teamId || undefined,
        agent_id: agentId || undefined,
        granularity: granularity || undefined,
        business_hours: businessHours || undefined,
      },
    });
  }
}

export default new AiAssistantsReportsAPI();
